import { Navigate, useRoutes } from "react-router-dom";
import Login from "../pages/login";
import PageNotFound from "../pages/not-found";
import ForgotPassword from "../pages/forgot-password";
import ResetPassword from "../pages/reset-password";
import protectRoutes from "./protected";
import TwoFactorAuthentication from "../pages/two-factor-verify";
import CreateAccount from "../pages/create-account";
import storage from "../helpers/storage";
import AuthGuard from "./handler/auth-guard";

function AppRoutes() {
  //const token = storage.getToken();
  const token = true;
  const router = [
    {
      path: "",
      element: <Navigate to={"/dashboard"} />,
    },
    {
      path: "login",
      element: (
        <AuthGuard>
          <Login />
        </AuthGuard>
      ),
    },
    {
      path: "create-account",
      element: (
        <AuthGuard>
          <CreateAccount />
        </AuthGuard>
      ),
    },
    {
      path: "two-factor-authentication",
      element: (
        <AuthGuard>
          <TwoFactorAuthentication />
        </AuthGuard>
      ),
    },
    {
      path: "forgot-password",
      element: (
        <AuthGuard>
          <ForgotPassword />
        </AuthGuard>
      ),
    },
    {
      path: "reset-password/:token",
      element: (
        <AuthGuard>
          <ResetPassword />
        </AuthGuard>
      ),
    },
    {
      path: "*",
      element: <PageNotFound />,
    },
  ];

  const mainRoutes = token ? protectRoutes : [];
  const routes = useRoutes([...router, ...mainRoutes]);
  return <>{routes}</>;
}

export default AppRoutes;
